import './index_mWeb.css';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { View, Text } from '../../../component';
import { createDeepObject, isMobileBrowser } from '../../../utilities/helper';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import useTheme from '../../../utilities/hooks/theme';
import useGame from '../../../utilities/hooks/game';
import Constants from '../../../constants';
import I18t from '../../../utilities/locale';
import React from 'react';

interface FilterSubItemProps {
  item: any;
  key: any;
  onPressFilter: any;
  theme: any;
}

const FilterSubItem = ({ item, onPressFilter }: FilterSubItemProps) => {
  const { title = '', isSelected = false } = item;

  const subItemContainer = {
    border: isSelected ? 'none' : '1px solid #fff',
    backgroundColor: isSelected ? '#ffc400' : 'transparent'
  };
  const titleColor = {
    color: isSelected ? '#000' : 'white'
  };

  return (
    <View
      className={'contest-filter-sub-item-wrapper_mWeb'}
      style={subItemContainer}
      onPress={onPressFilter}>
      <Text className={'contest-filter-sub-item-title'} style={titleColor}>
        {title}
      </Text>
    </View>
  );
};

interface FilterItemProps {
  listItem: any;
  key: any;
  onPressFilter: any;
  theme: any;
  listItemIndex: any;
}

const FilterItem = ({ listItem, onPressFilter, theme }: FilterItemProps) => {
  const { list = [] } = listItem;
  const itemTitle = {
    color: '#fff'
  };
  const divider = {
    backgroundColor: '#6B6E74'
  };
  return (
    <View className={'contest-filter-item-wrapper'}>
      <Text className={'contest-filter-item-title'} style={itemTitle}>
        {listItem.title}
      </Text>
      <View className={'contest-filter-sub-item-container_mWeb'}>
        {list.map((item: any, index: any) => {
          return (
            <FilterSubItem
              item={item}
              key={index}
              theme={theme}
              onPressFilter={() => {
                onPressFilter(index);
              }}
            />
          );
        })}
      </View>
      <View className={'contest-filter-divider'} style={divider} />
    </View>
  );
};

interface Props {
  visible: boolean;
  onPressDismiss?: () => void;
  onApplyFilter: any;
  onClearFilter: any;
}
const ContestFilter = ({ visible, onPressDismiss, onApplyFilter, onClearFilter }: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const { updateContestFilter, contestFilter: contestFilterList } = useGame();

  const dispatch = useDispatch();
  const [selected, setSelected] = useState(false);

  const onPressFilter = (itemIndex: any, subItemIndex: any) => {
    contestFilterList[itemIndex].list[subItemIndex].isSelected =
      !contestFilterList[itemIndex].list[subItemIndex].isSelected;
    dispatch(updateContestFilter(contestFilterList));
    setSelected(!selected);
  };

  const filterWrapper = {
    backgroundColor: '#192330'
  };

  const buttonApply = {
    width: '120px',
    fontFamily: 'Poppins',
    marginLeft: '10px'
  };

  const buttonClear = {
    marginLeft: '10px',
    width: '120px',
    fontFamily: 'Poppins'
  };

  const onPressClear = () => {
    dispatch(updateContestFilter(createDeepObject(Constants.ContestListFilter)));
    setSelected(!selected);
    onClearFilter();
  };

  let { themeType = '' } = useSelector((state: any) => state.setting);

  const bottomSheetWidth = isMobileBrowser ? 'root_mobile' : 'root';
  let className = `${bottomSheetWidth}`;
  className += themeType === 'dark' ? ' dark' : ' light';

  return (
    <BottomSheet className={`${className}`} onDismiss={onPressDismiss} open={visible}>
      <View className={'contest-filter-container_mWeb'} style={filterWrapper}>
        {contestFilterList.map((item: any, index: any) => {
          return (
            <FilterItem
              listItem={item}
              key={index}
              listItemIndex={index}
              onPressFilter={(subItemIndex: any) => {
                onPressFilter(index, subItemIndex);
              }}
              theme={theme}
            />
          );
        })}
        <View className={'contest-filter-button-container_mWeb'}>
          <button
            className="contest-filter-clear-btn_mWeb"
            style={buttonApply}
            onClick={onPressClear}>
            {I18t.t('clear')}
          </button>
          <button
            className="contest-filter-apply-btn_mWeb"
            style={buttonClear}
            onClick={onApplyFilter}>
            {I18t.t('Apply')}
          </button>
        </View>
      </View>
    </BottomSheet>
  );
};
export default React.memo(ContestFilter);
